
<div class="table-responsive margin-top-15 table-view">
    <h5 class="table-title">Man Hour Calculation</h5>
    <button [disabled]="DisableExport" class="btn btn-primary primary-btn button-excel"  style="margin-bottom: 10px;" (click)="exportToExcel()">
      <i class="fa fa-file-excel-o"></i>Export To Excel</button>
    <p-table [value]="ManHourCalculationData" [scrollable]="false" scrollHeight="500px" dataKey="Id" editMode="row" id="ManHourTableToExport">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:220px;">Unit</th>
          <th class="center-table">Staff Hours</th>
          <th class="center-table">Contractor Hours</th>
          <th class="center-table">Actions</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-records
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="records">
          <td style="width:220px;">
            {{ records.category }}
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="records.StaffHours"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                (click)="GetManHourSelectedDetails(records.UnitId,records.category,1)" data-target="#AT"> {{ records.StaffHours }}</a>               
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="records.ContractorHours"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                (click)="GetManHourSelectedDetails(records.UnitId,records.category,2)" data-target="#AT">  {{ records.ContractorHours }}</a>                              
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table" *ngIf="records.category != 'Total'">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(records)"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(records)"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(records, ri)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
</div>

<div class="modal fade PDModal" data-backdrop="static" style="opacity:1 !important;" id="AT" role="dialog">
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of ManHourData; let i=index">
            <li><a (click)="Redirect(item.value,item.ID)">{{item.Text }}</a></li>
         </ng-container>   
        </ol>
        <span *ngIf="ManHourData?.length < 1" style="color:red;">No Records Found..</span>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
